<app-page>
  <div class="top-cta">
    <dx-button
      [text]="'COMMON.BACK' | translate"
      icon="back"
      type="default"
      class="integration-btn"
      (click)="navigateBack()"
    ></dx-button>

    <div class="registration-link-actions">

      @if(!editingLinkId) {
        <dx-button
          [text]="'COMMON.SAVE' | translate"
          type="normal"
          (click)="onFormSubmit()"
        ></dx-button>
      } @else {
        <dx-button
          icon="copy"
          [text]="'REGISTRATION-LINKS.FORM.COPY-REGISTRATION-LINK' | translate"
          type="normal"
          (click)="copyRegistrationLink()"
        ></dx-button>
        <dx-drop-down-button
          [splitButton]="true"
          [text]="'COMMON.SAVE' | translate"
          stylingMode="contained"
          type="normal"
          [dropDownOptions]="{ width: 230 }"
          (onButtonClick)="onFormSubmit()"
        >
          <dxi-item (click)="deleteRegistrationLink()">{{
            "REGISTRATION-LINKS.FORM.DELETE-REGISTRATION-LINK" | translate
          }}</dxi-item>
        </dx-drop-down-button>
      }
      
    </div>
  </div>

  <app-page-title
    [title]="
      editingLinkId
        ? ('REGISTRATION-LINKS.FORM.TITLE-EDIT' | translate)
        : ('REGISTRATION-LINKS.FORM.TITLE-ADD' | translate)
    "
  ></app-page-title>

  <app-panel>
    <div class="row">
      <!-- Left column: Internal Name + Title & Description -->
      <div class="col-md-6">
        <dx-form
          #formBasicData
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="registrationLinkForm"
        >
          <dxi-item
            itemType="group"
            cssClass="text-caption"
            [caption]="'COMMON.GENERAL' | translate"
          >
            <dxi-item dataField="name">
              <dxo-label
                [text]="'REGISTRATION-LINKS.FORM.INTERNAL-NAME' | translate"
              ></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.INTERNAL-NAME-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>

            <dxi-item
              itemType="group"
              cssClass="text-caption"
              [caption]="'REGISTRATION-LINKS.FORM.VISIBLE-DURING-REGISTRATION-PROCESS' | translate"
            >
              <dxi-item dataField="title" [editorType]="'dxTextBox'">
                <dxo-label [text]="'COMMON.FIELDS.TITLE' | translate"></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.TITLE-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>

              <dxi-item
                dataField="description"
                [editorType]="'dxTextArea'"
                [label]="{ text: ('COMMON.FIELDS.DESCRIPTION' | translate) }"
                [editorOptions]="{
                  placeholder: ('REGISTRATION-LINKS.FORM.DESCRIPTION-PLACEHOLDER' | translate),
                  height: 105
                }"
              ></dxi-item>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </div>

      <!-- Right column: Location, Role, Training Groups, Learning Paths -->
      <div class="col-md-6">
        <dx-form
          #formAutomaticAllocationsData
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="registrationLinkForm"
          validationGroup="customFields"
        >
          <dxi-item
            itemType="group"
            cssClass="text-caption"
            [caption]="'REGISTRATION-LINKS.FORM.AUTOMATIC-ALLOCATIONS' | translate"
          >
            <dxi-item dataField="locationId">
              <div *dxTemplate>
                <dx-drop-down-box
                  #locationDropDown
                  [(value)]="registrationLinkForm.locationId"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="('COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate) + ' *'"
                  [dataSource]="locations"
                  labelMode="floating"
                  stylingMode="outlined"
                  [showClearButton]="true"
                  (onValueChanged)="locationDropDown.instance.close()"
                >
                  <dx-validator validationGroup="customFields">
                    <dxi-validation-rule
                      type="required"
                      [message]="'VALIDATIONS.LOCATION-REQUIRED' | translate"
                    ></dxi-validation-rule>
                  </dx-validator>
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="locations"
                      keyExpr="id"
                      dataStructure="plain"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      (onItemClick)="onLocationSelected($event)"
                    >
                    </dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
            <dxi-item
              [editorOptions]="rolesOptions"
              dataField="roleId"
              editorType="dxSelectBox"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.ROLE' | translate"
              ></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.ROLE-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item>
              <dxo-label [text]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [(value)]="registrationLinkForm.trainingGroupIds"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
                  [dataSource]="trainingGroups"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="trainingGroups"
                      dataStructure="plain"
                      keyExpr="id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="onTrainingGroupSelected($event)"
                    ></dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>

            <dxi-item>
              <dxo-label [text]="'COMMON.FIELDS.LEARNING-PATHS' | translate"></dxo-label>
              <div *dxTemplate>
                <dx-drop-down-box
                  [(value)]="registrationLinkForm.learningPathIds"
                  [inputAttr]="{ 'aria-label': 'Owner' }"
                  valueExpr="id"
                  displayExpr="name"
                  [label]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
                  [dataSource]="learningPaths"
                  labelMode="floating"
                  stylingMode="outlined"
                >
                  <div *dxTemplate="let data of 'content'">
                    <dx-tree-view
                      [searchEnabled]="true"
                      [dataSource]="learningPaths"
                      dataStructure="plain"
                      keyExpr="id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      [selectNodesRecursive]="false"
                      displayExpr="name"
                      [selectByClick]="true"
                      (onItemSelectionChanged)="onLearningPathSelected($event)"
                    ></dx-tree-view>
                  </div>
                </dx-drop-down-box>
              </div>
            </dxi-item>
          </dxi-item>

        </dx-form>
      </div>
    </div>
  </app-panel>
  <app-panel>
    <div class="panel-title">
      {{ 'REGISTRATION-LINKS.FORM-FIELDS.TITLE' | translate }}
      <span class="new-badge">{{ 'COMMON.NEW' | translate }}</span>
    </div>
    <p 
      class="text-caption"
      [innerHTML]="'REGISTRATION-LINKS.FORM-FIELDS.DESCRIPTION' | translate"
    ></p>
    <app-registration-field-config
      #registrationFieldConfigs 
      [formLabel]="'REGISTRATION-LINKS.FORM-FIELDS.CREATE-ACCOUNT' | translate"
      [fields]="registrationLinkForm.fieldConfigs"
    ></app-registration-field-config>
  </app-panel>
  <app-panel *ngIf="isBrokerPoolTenant">
    <div class="panel-title">
      {{ 'REGISTRATION-LINKS.QUESTIONS.TITLE' | translate }}
      <span class="new-badge">{{ 'COMMON.NEW' | translate }}</span>
    </div>
    <p 
      class="text-caption"
      [innerHTML]="'REGISTRATION-LINKS.QUESTIONS.DESCRIPTION' | translate"
    ></p>
    <app-registration-link-questions
      #registrationQuestions
      [(questions)]="registrationLinkForm.questions"
      [trainingGroups]="trainingGroups"
    ></app-registration-link-questions>
  </app-panel>
  <app-panel *ngIf="isBrokerPoolTenant">
    <div class="panel-title">
      {{ 'REGISTRATION-LINKS.REGISTRATION-FLOW.TITLE' | translate }}
      <span class="new-badge">{{ 'COMMON.NEW' | translate }}</span>
    </div>
    <p 
      class="text-caption"
      [innerHTML]="'REGISTRATION-LINKS.REGISTRATION-FLOW.DESCRIPTION' | translate"
    ></p>
    <app-registration-flow 
      [(allowAddingEmployees)]="registrationLinkForm.allowAddingEmployees"
      [(createLocationAutomatically)]="registrationLinkForm.createLocationAutomatically"
      [(parentLocationId)]="registrationLinkForm.parentLocationId"
      [locations]="locations"
    ></app-registration-flow>
  </app-panel>
  <app-panel
    [title]="'REGISTRATION-LINKS.FORM.REGISTRATIONS' | translate"
    *ngIf="registrationLinkFull"
  >
    <app-table
      [columns]="personsColumns"
      [showSearch]="true"
      [data]="registrationLinkFull.persons || []"
      [searchPlacehoder]="'COMMON.SEARCH' | translate"
      [showExport]="true"
      [exportName]="'REGISTRATION-LINKS.FORM.REGISTRATIONS' | translate"
    ></app-table>
  </app-panel>
</app-page>
